import { getApi } from 'apis';

export const getAllConstantDropdown = async (params: any) => {
	return await getApi('/data', params);
};
